import { type CareCirclesInitial } from '@/cam-admin/care-circles/CareCircles';
import { makeSceneLookup, type Scene } from '@/designs-dev/scenes';

// Every state the care circles index can be in, paired with the `initial`
// props that drive it there. Shared by the live state select (CareCirclesStage)
// so the set of states is defined once.
export const careCirclesScenes: Scene<CareCirclesInitial>[] = [
  {
    id: 'index',
    label: 'Your caseload',
    kind: 'happy',
    repro: 'How the page opens: the signed-in CAM’s own circles',
    initial: {},
  },
  {
    id: 'all',
    label: 'All care circles',
    kind: 'happy',
    repro: 'The caseload filter set to every circle across the team',
    initial: { caseload: 'all' },
  },
  {
    id: 'unassigned',
    label: 'Unassigned circles',
    kind: 'edge',
    repro: 'Circles with no case manager yet — where the coral link lands',
    initial: { caseload: 'unassigned' },
  },
  {
    id: 'search',
    label: 'Filtered search',
    kind: 'happy',
    repro: 'A query that matches some circles',
    initial: { search: 'whitfield' },
  },
  {
    id: 'no-results',
    label: 'No matching circles',
    kind: 'empty',
    repro: 'A query that matches nothing',
    initial: { search: 'zzzzzz' },
  },
  {
    id: 'empty',
    label: 'No circles yet',
    kind: 'empty',
    repro: 'An account with no care circles',
    initial: { empty: true },
  },
];

export const careCirclesSceneById = makeSceneLookup(careCirclesScenes);
